<template>
  <transition name="slide-up">
    <div v-show="visible" class="coze-chat-container" :style="modalStyle">
      <div
        class="chat-header"
        @click.stop="toggleExpand"
        @mousedown.stop="startDrag"
      >
        <div class="header-left">
          <!-- <img :src="botAvatar" alt="AI助手头像" class="avatar"> -->
          <span class="title">待审核数据变更对比</span>
          <!-- <span class="status-dot" :class="{ online: isConnected }"></span> -->
        </div>
        <div class="header-right">
          <!-- <i class="el-icon-full-screen" @click.stop="screen"></i> -->
          <i class="el-icon-minus" @click.stop="minimize"></i>
          <i class="el-icon-close" @click.stop="close"></i>
        </div>
      </div>

      <div v-show="expanded" class="chat-body">
        <!-- <div style="
            display: flex;
            justify-content: flex-start;
            align-items: center;
          ">
          属性名称：原数据<span style="color: #3498db; font-size: 20px">→</span>新数据
        </div> -->
        <div
          v-if="
            record &&
            record.nowTransContent &&
            record.changeTransContent &&
            diff(record.nowTransContent, record.changeTransContent).length > 0
          "
          v-for="item in diff(
            record.changeTransContent,
            record.nowTransContent
          )"
        >
          <div class="property-name">{{ item.field }}：</div>
          <div class="flex flex-around align-items-center">
            <span
              class="property-old"
              :style="{
                cursor: cursorPointer.includes(item.field)
                  ? 'pointer'
                  : 'default',
                color:cursorPointer.includes(item.field)
                  ? '#2155b5'
                  : '',
              }"
              @click="
                handleClick(JSON.parse(record.changeTransContent), item.key)
              "
              >{{ item.obj1 }}</span
            >
            <img class="arrows" src="@/assets/images/r-arrows.png" alt="" />
            <!-- <span style="color: #3498db; font-size: 20px">→</span> -->
            <span
              class="property-new"
              :style="{
                cursor: cursorPointer.includes(item.field)
                  ? 'pointer'
                  : 'default',
                color:cursorPointer.includes(item.field)
                  ? '#2155b5'
                  : '',
              }"
              @click="handleClick(JSON.parse(record.nowTransContent), item.key)"
              >{{ item.obj2 }}</span
            >
          </div>
        </div>
        <div
          v-if="
            !record ||
            !record.nowTransContent ||
            !record.changeTransContent ||
            diff(record.nowTransContent, record.changeTransContent).length == 0
          "
          style="
            width: 100%;
            text-align: center;
            line-height: 150px;
            font-size: 18px;
          "
        >
          暂无数据改变
        </div>
      </div>
    </div>
    <!-- 原有模板结构保持不变 -->
  </transition>
</template>

<script>
import { getAction, postAction } from "@/api";
import { FIELD_LABELS, CURSOR_POINTER } from "@/components/auditPage/data.js";
import mixin from "@/utils/mixin"
export default {
  mixins:[mixin],
  name: "CozeChatWidget",
  props: {
    // userAvatar: {
    //     type: String,
    //     default: 'https://picsum.photos/40/40?random=user'
    // },
    // botAvatar: {
    //     type: String,
    //     default: 'https://picsum.photos/40/40?random=bot'
    // }
  },
  data() {
    return {
      cursorPointer: CURSOR_POINTER,
      visible: false,
      expanded: true,
      heights: "600px",
      isDragging: false,
      isResizing: false,
      startX: 0,
      startY: 0,
      startWidth: 0,
      startHeight: 0,
      startLeft: 0,
      startTop: 0,
      modalStyle: {
        right: "0px",
        top: "0px",
        width: "1200px",
        height: "600",
      },
      record: {
        // nowTransContent: {
        //   name: "工作室名称",
        //   address: "工作室地点",
        //   foundTime: "建设日期",
        //   applyYear: "申报年份",
        //   declarationName: "申报书",
        // },
        // changeTransContent: {
        //   name: "工作室名称1",
        //   address: "工作室地点1",
        //   foundTime: "建设日期1",
        //   applyYear: "申报年份",
        //   declarationName: "申报书",
        // }
      },
      fieldLabels: FIELD_LABELS[1]["GZSJIBENXINXI"],
      type: "1",
    };
  },
  mounted() {
    this.setInitialSize();
    document.addEventListener("mousemove", this.handleMouseMove);
    document.addEventListener("mouseup", this.handleMouseUp);
    document.addEventListener("keyup", this.handleKeyUp);

    // 初始位置居中
    this.centerModal();
  },
  beforeDestroy() {
    document.removeEventListener("mousemove", this.handleMouseMove);
    document.removeEventListener("mouseup", this.handleMouseUp);
    document.removeEventListener("keyup", this.handleKeyUp);
  },
  methods: {
    init(record, type) {
      this.visible = true;
      this.type = type;
      if (type == "1") {
        this.fieldLabels = FIELD_LABELS[1]["GZSJIBENXINXI"];
      } else if (type == "2") {
        this.fieldLabels = FIELD_LABELS[2]["PPJIBENXINXI"];
      } else if (type == "3") {
        this.fieldLabels = FIELD_LABELS[3]["WKJIBENXINXI"];
      }
      this.record = record;
      console.log(record);
      // console.log(record);
      this.getData();
    },
    handleClick(data, key) {
      this.$emit("preview", data, key);
    },
    getData() {
      let data = {
        // applyType: this.type,
        // pageNo: this.pagination.current,
        // pageSize: this.pagination.pageSize,
        id: this.record?.id,
      };
      getAction("/lx/lxApply/queryById", data).then((res) => {
        if (res.code === 200) {
          console.log(res, "444444");
          let data = res.result;
          if (data) {
            console.log(data, "444444");
            this.record = data;
            // this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    toggleExpand() {
      this.expanded = !this.expanded;
      if (!this.expanded) {
        this.heights = "68px";
        this.modalStyle.height = "68px";
      } else {
        this.heights = "600px";
        this.modalStyle.height = "600px";
      }
    },
    minimize() {
      this.expanded = false;
      this.modalStyle.height = "68px";
      this.heights = "68px";
    },
    setInitialSize() {
      const sizeMap = {
        small: { width: "300px", height: this.heights },
        medium: { width: "300px", height: this.heights },
        large: { width: "300px", height: this.heights },
      };

      const size = sizeMap[this.size] || sizeMap.medium;
      this.modalStyle.width = size.width;
      this.modalStyle.height = size.height;
    },

    centerModal() {
      const modalWidth = parseInt(this.modalStyle.width);
      const modalHeight = parseInt(this.modalStyle.height);

      this.modalStyle.right = `40px`;
      this.modalStyle.top = `200px`;
      this.$emit("position-change", {
        x: parseInt(this.modalStyle.right),
        y: parseInt(this.modalStyle.top),
        width: modalWidth,
        height: modalHeight,
      });
    },

    resetModal() {
      this.setInitialSize();
      this.centerModal();
    },

    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startRight = parseInt(this.modalStyle.right);
      this.startTop = parseInt(this.modalStyle.top);
      e.preventDefault();
    },
    startResize(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startWidth = parseInt(this.modalStyle.width);
      this.startHeight = parseInt(this.modalStyle.height);
      this.startRight = parseInt(this.modalStyle.right);
      this.startTop = parseInt(this.modalStyle.top);
      e.stopPropagation();
      e.preventDefault();
    },

    handleMouseMove(e) {
      if (this.isDragging) {
        const dx = this.startX - e.clientX;
        const dy = e.clientY - this.startY;

        let newRight = this.startRight + dx;
        let newTop = this.startTop + dy;

        // 边界检测，防止窗口拖出屏幕外
        const maxRight = window.innerWidth - 50;
        const maxTop = window.innerHeight - 100;

        newRight = Math.max(20, Math.min(newRight, maxRight));
        newTop = Math.max(20, Math.min(newTop, maxTop));

        this.modalStyle.right = `${newRight}px`;
        this.modalStyle.top = `${newTop}px`;
      }

      if (this.isResizing) {
        const dx = this.startX - e.clientX;
        const dy = e.clientY - this.startY;

        const newWidth = Math.max(300, this.startWidth + dx);
        const newHeight = Math.max(400, this.startHeight - dy);

        // 调整位置，使右下角固定
        const newRight = this.startRight + dx;
        const newTop = this.startTop;

        // 边界检测
        if (
          newRight > 20 &&
          newRight < window.innerWidth - 100 &&
          newTop > 20 &&
          newTop < window.innerHeight - 100
        ) {
          this.modalStyle.width = `${newWidth}px`;
          this.modalStyle.height = `${newHeight}px`;
          this.modalStyle.right = `${newRight}px`;
        }
      }
    },
    handleMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
    },

    close() {
      this.visible = false;
      // this.$emit("close");
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.coze-chat-container {
  position: fixed;
  right: 40px;
  top: 200px;
  width: 300px;
  /* max-height: 600px; */
  max-height: 600px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  z-index: 9999;
  border: 1px solid #ebeef5;
}

.chat-header {
  padding: 15px;
  /* background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%); */
  // background: linear-gradient(135deg, #e97166 0%, #d82f23 100%);
  background: linear-gradient(to right, #7ba6f5 0%, #2155b5 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: move;
  user-select: none;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  padding: 1px;
}

.title {
  font-weight: 500;
  font-size: 16px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff4d4f;
}

.status-dot.online {
  background: #52c41a;
}

.header-right {
  display: flex;
  gap: 12px;
  color: rgba(255, 255, 255, 0.8);
}

.header-right i {
  cursor: pointer;
  transition: all 0.2s;
}

.header-right i:hover {
  color: white;
  transform: scale(1.1);
}

.chat-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #f8f9fa;
  overflow-y: auto;
  // scrollbar-width: none;
  /* Firefox */
  // -ms-overflow-style: none;
  /* IE/Edge */
  padding: 10px;
  box-sizing: border-box;
  color: #606266;

  .property-name {
    width: 100%;
    margin: 8px;
    position: relative;
    padding-left: 8px;
    box-sizing: border-box;
    font-size: 16px;
    color: #000;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 14px;
      background: #2155b5;
      border-radius: 5px;
    }
  }

  .arrows {
    margin: 0 6px;
    height: 26px;
  }

  // .property-new {
  //   color: #52c41a;
  // }

  .property-old,
  .property-new {
    width: 45%;
    text-align: center;
    display: inline-block;
    white-space: pre-wrap; /* 或者使用 pre-line，根据具体需求选择 */
    word-break: break-all; /* 允许在单词内换行 */
  }
}

/* Chrome/Safari/Opera */
.chat-body::-webkit-scrollbar {
  display: none;
}
</style>
